import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ClientHeader from "../../../common/ClientHeader";
import ProtectedPage from "../../../common/ProtectedPage";
import { CategoriesQueriesClient } from "../../../../requests/queries/CategoriesQueries";
import "./TermsStyles.css";
import Sidebar from "../../../common/Sidebar";

export default function Terms({ currentCommand, setCurrentCommand }) {
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const res = await CategoriesQueriesClient.findAll();
                setCategories(res.data.categories);
            } catch (err) {
                console.error("Erreur lors du chargement des catégories:", err);
            }
        };
        fetchCategories();
    }, []);

    return (
        <ProtectedPage key={`terms-${currentCommand?.id}`} permissionsNeeded="client" needToBeAuthenticated={false} redirectPath="/client-auth">
            <div className="patricians-layout">
                <ClientHeader displayCart={false} currentCommand={currentCommand} setCurrentCommand={setCurrentCommand} />
                <div className="patricians-main-content">

                    {/* Zone principale avec le contenu */}
                    <div className="policy-container">
                        <div className="policy-content">
                            <div className="policy-header">
                                <h1 className="policy-title">Refund & Returns Policy – Patricians</h1>
                                <p className="policy-subtitle">Our return and refund conditions</p>
                            </div>

                            <div className="policy-section">
                                <h2>Return Period</h2>
                                <div className="policy-text">
                                    <p>
                                        You may request a return or refund within 14 days of receiving your order.
                                    </p>
                                </div>
                            </div>

                            <div className="policy-section">
                                <h2>Conditions for Returns</h2>
                                <div className="policy-text">
                                    <p>To be eligible for a return:</p>
                                    <ul>
                                        <li>The item must be unused, unworn, and in its original condition</li>
                                        <li>The original tag must still be attached</li>
                                        <li>The item must be returned in its original packaging</li>
                                    </ul>
                                    <p>Items that do not meet these conditions will not be accepted for a refund.</p>
                                </div>
                            </div>

                            <div className="policy-section">
                                <h2>Non-Returnable Items</h2>
                                <div className="policy-text">
                                    <p>
                                        Items with removed tags, visible signs of wear, washing, or damage caused by the customer are not eligible for a refund.
                                    </p>
                                </div>
                            </div>

                            <div className="policy-section">
                                <h2>Return Process</h2>
                                <div className="policy-text">
                                    <p>
                                        To initiate a return, please contact us at <a href="mailto:contact@patricians.xyz">contact@patricians.xyz</a> within 14 days of delivery. Once your return request is approved, you will receive instructions on how to send the item back.
                                    </p>
                                </div>
                            </div>

                            <div className="policy-section">
                                <h2>Refunds</h2>
                                <div className="policy-text">
                                    <p>
                                        After receiving and inspecting the returned item, we will notify you of the approval or rejection of your refund.
                                    </p>
                                    <p>
                                        If approved, the refund will be processed to your original payment method within a few business days.
                                    </p>
                                </div>
                            </div>

                            <div className="policy-section">
                                <h2>Return Shipping Costs</h2>
                                <div className="policy-text">
                                    <p>
                                        Return shipping costs are the responsibility of the customer, unless the item arrived damaged or incorrect.
                                    </p>
                                </div>
                            </div>

                            <div className="policy-section">
                                <h2>Damaged or Incorrect Items</h2>
                                <div className="policy-text">
                                    <p>
                                        If you receive a damaged or incorrect item, please contact us within 48 hours of delivery with photo evidence so we can resolve the issue promptly.
                                    </p>
                                </div>
                            </div>

                            <div className="policy-section">
                                <h2>Questions</h2>
                                <div className="policy-text">
                                    <p>
                                        For any questions regarding returns or refunds, contact us at <a href="mailto:contact@patricians.xyz">contact@patricians.xyz</a>.
                                    </p>
                                </div>
                            </div>

                            <div className="policy-footer">
                                <p className="policy-update">
                                    <strong>Last updated:</strong> {new Date().toLocaleDateString('en-GB')}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ProtectedPage>
    );
}
